import {
    IconPoll,
    IconPreviewContact,
    IconPreviewDocument,
    IconPreviewLiveLocation,
    IconPreviewLocation,
    IconPreviewPhoto,
    IconPreviewVideo,
    IconPreviewVideoCall,
    IconPreviewVoice,
    IconPreviewVoiceCall,
} from '../../Common/Icons';
import { isLiveLocationLabel } from '../../../features/location/locationRules';
import { POLL_MESSAGE_TYPE } from '../../../Helpers/Chat/Constant';

const FIXED_ICONS = {
    image: IconPreviewPhoto,
    video: IconPreviewVideo,
    file: IconPreviewDocument,
    contact: IconPreviewContact,
    [POLL_MESSAGE_TYPE]: IconPoll,
};

/**
 * Icon drawn before the one-line preview of a message. The chat list and the reply quote
 * both ask here, so a type never reads with two different glyphs.
 *
 * @param {string} messageType message_type of the message.
 * @param {object} msgBody Message body.
 * @param {object|string} metaData Message meta_data, parsed or not.
 * @returns {React.ComponentType|null} The icon, or null for a type drawn without one.
 */
export const getPreviewIcon = (messageType, msgBody = {}, metaData = {}) => {
    switch (messageType) {
        // An uploaded audio file reads as a document; only a recording is a voice message.
        case 'audio':
            return msgBody?.media?.audioType === 'recording' ? IconPreviewVoice : IconPreviewDocument;
        case 'location':
            return isLiveLocationLabel(msgBody, metaData) ? IconPreviewLiveLocation : IconPreviewLocation;
        case 'call':
            return msgBody?.callType === 'video' ? IconPreviewVideoCall : IconPreviewVoiceCall;
        default:
            return FIXED_ICONS[messageType] || null;
    }
};
